(function () {
  'use strict';

  var GLOBAL_NAME = 'VLWelcomePopupCoordinator';
  var CONFIG_SELECTOR = '[data-vl-welcome-popup-coordinator-config]';
  var REOPEN_SELECTOR = '[data-vl-welcome-popup-reopen]';
  var POPUP_ACTIVE_BODY_CLASS = 'vl-welcome-popup-active';
  var VALID_ROUTES = ['homepage_experiment', 'standard_welcome'];
  var DECISION_VERSION = 2;

  if (window[GLOBAL_NAME]) return;

  var configNode = document.querySelector(CONFIG_SELECTOR);
  var config;

  try {
    config = JSON.parse(configNode ? configNode.textContent : '');
  } catch (error) {
    return;
  }

  var storageKey = config.storageKey || 'vl_welcome_popup_decision';
  var claimStorageKey = config.claimStorageKey || 'vl_welcome_popup_claim';
  var lockName = config.lockName || 'vl-welcome-popup-decision';
  var runVersion = 0;
  var startPromise = null;
  var pageAutoAuthorized = false;
  var popupActive = false;
  var formOpenTimer = null;
  var assignmentTimer = null;
  var reopenRenderTimer = null;
  var klaviyoOverlayTimers = [];
  var reopenRenderBlocked = false;
  var reopenRoot = document.querySelector(REOPEN_SELECTOR);
  var pageInstanceId = createId();

  var state = {
    status: 'idle',
    pathname: normalizePath(window.location.pathname),
    excluded: false,
    identified: null,
    gateReason: null,
    storageStatus: 'unchecked',
    lockStrategy: null,
    decision: null,
    ptStatus: 'idle',
    formStatus: 'idle',
    activeFormId: null,
    actualExposure: false,
    displayStatus: 'waiting_for_dom',
    reopenVisible: false,
    implementationVersion: 'welcome-coordinator-v2'
  };

  var displayReadyPromise = createDisplayReadyPromise();

  function setPopupLayerActive(active) {
    if (document.body && document.body.classList) {
      document.body.classList.toggle(POPUP_ACTIVE_BODY_CLASS, active === true);
    }
    if (active !== true) clearKlaviyoOverlayMarking();
  }

  function emit(name, detail) {
    document.dispatchEvent(
      new CustomEvent(name, {
        detail: detail || {}
      })
    );
  }

  function copy(value) {
    if (value == null) return value;

    try {
      return JSON.parse(JSON.stringify(value));
    } catch (error) {
      return null;
    }
  }

  function normalizePath(value) {
    var path = String(value || '/').split('?')[0].split('#')[0] || '/';
    var localeRoot = String(config && config.localeRoot ? config.localeRoot : '/');

    if (localeRoot.charAt(0) !== '/') localeRoot = '/' + localeRoot;
    if (localeRoot.length > 1) localeRoot = localeRoot.replace(/\/+$/, '');

    if (localeRoot !== '/') {
      if (path === localeRoot) {
        path = '/';
      } else if (path.indexOf(localeRoot + '/') === 0) {
        path = path.slice(localeRoot.length) || '/';
      }
    }

    if (path.charAt(0) !== '/') path = '/' + path;
    if (path.length > 1) path = path.replace(/\/+$/, '');

    return path || '/';
  }

  function isValidDecision(value) {
    return Boolean(
      value &&
      typeof value === 'object' &&
      VALID_ROUTES.indexOf(value.route) !== -1 &&
      value.status === 'reserved' &&
      typeof value.createdAt === 'number' &&
      typeof value.reservationId === 'string' &&
      value.reservationId
    );
  }

  function normalizeDecision(decision) {
    var next = copy(decision);
    var isLegacy = Number(next.decisionVersion) !== DECISION_VERSION;

    next.decisionVersion = DECISION_VERSION;
    next.autoOpenConsumed = isLegacy
      ? true
      : next.autoOpenConsumed === true;
    next.reopenAvailable = isLegacy
      ? true
      : next.reopenAvailable === true;
    next.reopenDismissed = next.reopenDismissed === true;
    next.completed = next.completed === true;
    next.popupActive = isLegacy ? false : next.popupActive === true;
    next.popupActiveAt = next.popupActive && typeof next.popupActiveAt === 'number'
      ? next.popupActiveAt
      : null;
    next.popupOwnerId = next.popupActive && typeof next.popupOwnerId === 'string'
      ? next.popupOwnerId
      : null;
    next.manualFallback = next.manualFallback === 'standard_welcome'
      ? 'standard_welcome'
      : null;
    next.reservationOwnerId = typeof next.reservationOwnerId === 'string'
      ? next.reservationOwnerId
      : null;
    next.quizProgress = next.quizProgress && typeof next.quizProgress === 'object'
      ? next.quizProgress
      : null;

    return { decision: next, migrated: isLegacy };
  }

  function readDecision() {
    var raw;

    try {
      raw = window.localStorage.getItem(storageKey);
      state.storageStatus = 'available';
    } catch (error) {
      state.storageStatus = 'read_failed';
      return { ok: false, reason: 'storage_read_failed', decision: null };
    }

    if (raw === null) {
      return { ok: true, reason: 'empty', decision: null };
    }

    try {
      var decision = JSON.parse(raw);
      if (!isValidDecision(decision)) {
        state.storageStatus = 'invalid';
        return { ok: false, reason: 'storage_invalid', decision: null };
      }

      var normalized = normalizeDecision(decision);
      if (normalized.migrated) {
        window.localStorage.setItem(storageKey, JSON.stringify(normalized.decision));
      }

      return { ok: true, reason: 'found', decision: normalized.decision };
    } catch (error) {
      state.storageStatus = 'invalid';
      return { ok: false, reason: 'storage_invalid', decision: null };
    }
  }

  function writeDecision(decision) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(decision));
      var result = readDecision();

      if (!result.ok || !result.decision ||
          result.decision.reservationId !== decision.reservationId) {
        state.storageStatus = 'verification_failed';
        return false;
      }

      state.storageStatus = 'written';
      state.decision = result.decision;
      return true;
    } catch (error) {
      state.storageStatus = 'write_failed';
      return false;
    }
  }

  function updateDecision(fields) {
    var result = readDecision();
    if (!result.ok || !result.decision) return false;

    var next = {};
    var key;

    for (key in result.decision) {
      if (Object.prototype.hasOwnProperty.call(result.decision, key)) {
        next[key] = result.decision[key];
      }
    }

    for (key in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, key)) {
        next[key] = fields[key];
      }
    }

    var written = writeDecision(next);
    if (written) renderReopen();
    return written;
  }

  function clearFormOpenTimer() {
    if (!formOpenTimer) return;
    window.clearTimeout(formOpenTimer);
    formOpenTimer = null;
  }

  function clearAssignmentTimer() {
    if (!assignmentTimer) return;
    window.clearTimeout(assignmentTimer);
    assignmentTimer = null;
  }

  function clearReopenRenderTimer() {
    if (reopenRenderTimer) {
      window.clearTimeout(reopenRenderTimer);
      reopenRenderTimer = null;
    }
    reopenRenderBlocked = false;
  }

  function delayReopenRender() {
    var configuredDelay = Number(config.reopenDelayMs);
    var delayMs = configuredDelay >= 0 ? configuredDelay : 600;

    clearReopenRenderTimer();
    if (delayMs === 0) return;

    reopenRenderBlocked = true;
    reopenRenderTimer = window.setTimeout(function () {
      reopenRenderTimer = null;
      reopenRenderBlocked = false;
      renderReopen();
    }, delayMs);
  }

  function shouldShowReopen(decision) {
    return Boolean(
      reopenRoot &&
      !state.excluded &&
      !(window.Shopify && window.Shopify.designMode) &&
      decision &&
      decision.reopenAvailable === true &&
      decision.reopenDismissed !== true &&
      decision.completed !== true &&
      decision.popupActive !== true &&
      !reopenRenderBlocked &&
      !popupActive
    );
  }

  function renderReopen() {
    if (!reopenRoot) return;
    var result = readDecision();
    var visible = result.ok && shouldShowReopen(result.decision);
    reopenRoot.hidden = !visible;
    state.reopenVisible = visible;
  }

  function markVisibleKlaviyoOverlay() {
    if (!popupActive ||
        typeof document.querySelectorAll !== 'function' ||
        typeof window.getComputedStyle !== 'function') {
      return false;
    }

    var dialogs = document.querySelectorAll('[role="dialog"]');

    for (var index = 0; index < dialogs.length; index += 1) {
      var dialog = dialogs[index];
      var rect = dialog.getBoundingClientRect();
      var style = window.getComputedStyle(dialog);

      if (style.position === 'fixed' &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          rect.width >= window.innerWidth * 0.9 &&
          rect.height >= window.innerHeight * 0.9) {
        dialog.classList.add('vl-welcome-popup-klaviyo-overlay');
        return true;
      }
    }

    return false;
  }

  function clearKlaviyoOverlayMarking() {
    while (klaviyoOverlayTimers.length) {
      window.clearTimeout(klaviyoOverlayTimers.pop());
    }

    if (typeof document.querySelectorAll !== 'function') return;

    var markedDialogs = document.querySelectorAll(
      '.vl-welcome-popup-klaviyo-overlay'
    );

    for (var index = 0; index < markedDialogs.length; index += 1) {
      markedDialogs[index].classList.remove(
        'vl-welcome-popup-klaviyo-overlay'
      );
    }
  }

  function scheduleKlaviyoOverlayMarking() {
    clearKlaviyoOverlayMarking();
    markVisibleKlaviyoOverlay();
    klaviyoOverlayTimers.push(
      window.setTimeout(markVisibleKlaviyoOverlay, 100),
      window.setTimeout(markVisibleKlaviyoOverlay, 300),
      window.setTimeout(markVisibleKlaviyoOverlay, 700)
    );
  }

  function enableReopen(reason) {
    var result = readDecision();
    if (!result.ok || !result.decision ||
        result.decision.completed || result.decision.reopenDismissed) {
      renderReopen();
      return false;
    }

    popupActive = false;
    setPopupLayerActive(false);
    state.status = reason || 'reopen_available';
    return updateDecision({
      popupActive: false,
      popupActiveAt: null,
      popupOwnerId: null,
      reopenAvailable: true
    });
  }

  function handleFormOpenFailure(reason) {
    var result = readDecision();
    if (!result.ok || !result.decision) return false;

    var shouldUseStandardFallback =
      result.decision.route === 'homepage_experiment' &&
      result.decision.actualExposure !== true;

    popupActive = false;
    setPopupLayerActive(false);
    state.formStatus = 'open_timeout';
    state.status = reason || 'form_open_timeout';

    return updateDecision({
      popupActive: false,
      popupActiveAt: null,
      popupOwnerId: null,
      formStatus: 'open_timeout',
      manualFallback: shouldUseStandardFallback
        ? 'standard_welcome'
        : (result.decision.route === 'homepage_experiment'
          ? null
          : result.decision.manualFallback),
      reopenAvailable: true
    });
  }

  function scheduleFormOpenFallback() {
    clearFormOpenTimer();
    var timeoutMs = Number(config.formOpenTimeoutMs) > 0
      ? Number(config.formOpenTimeoutMs)
      : 5000;

    formOpenTimer = window.setTimeout(function () {
      formOpenTimer = null;
      if (popupActive) handleFormOpenFailure('form_open_timeout');
    }, timeoutMs);
  }

  function scheduleAssignmentFallback() {
    clearAssignmentTimer();
    var timeoutMs = Number(config.assignmentTimeoutMs) > 0
      ? Number(config.assignmentTimeoutMs)
      : 5000;

    assignmentTimer = window.setTimeout(function () {
      assignmentTimer = null;
      var result = readDecision();
      if (!result.ok || !result.decision || result.decision.autoOpenConsumed) return;
      pageAutoAuthorized = false;
      updateDecision({
        autoOpenConsumed: true,
        reopenAvailable: true,
        manualFallback: 'standard_welcome',
        reservationOwnerId: null
      });
      state.status = 'assignment_timeout';
    }, timeoutMs);
  }

  function createId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var values = new Uint32Array(4);
      window.crypto.getRandomValues(values);
      return Array.prototype.map.call(values, function (value) {
        return value.toString(16);
      }).join('-');
    }

    return String(Date.now()) + '-' + String(Math.random()).slice(2);
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function createDisplayReadyPromise() {
    var configuredDelay = Number(config.displayDelayMs);
    var displayDelayMs = configuredDelay >= 0 ? configuredDelay : 2000;

    return new Promise(function (resolve) {
      function startDelay() {
        state.displayStatus = 'waiting_for_delay';
        window.setTimeout(function () {
          state.displayStatus = 'ready';
          resolve(true);
        }, displayDelayMs);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startDelay, { once: true });
        return;
      }

      startDelay();
    });
  }

  function isExcludedPath(pathname) {
    var paths = Array.isArray(config.excludedPaths) ? config.excludedPaths : [];

    for (var i = 0; i < paths.length; i += 1) {
      if (normalizePath(paths[i]) === pathname) return true;
    }

    return false;
  }

  function selectedStandardFormId() {
    var forms = config.standardWelcomeForms || {};
    var breakpoint = Number(config.mobileBreakpoint) || 749;
    var isMobile = window.matchMedia &&
      window.matchMedia('(max-width: ' + breakpoint + 'px)').matches;

    return isMobile ? forms.mobileFormId : forms.desktopFormId;
  }

  function checkIdentity(version) {
    var timeoutMs = Number(config.identityTimeoutMs) > 0
      ? Number(config.identityTimeoutMs)
      : 2000;

    state.status = 'checking_identity';
    state.gateReason = 'waiting_for_identification';

    return new Promise(function (resolve) {
      var settled = false;
      var pollTimer = null;
      var deadlineTimer = null;

      function finish(eligible, reason, identified) {
        if (settled || version !== runVersion) return;
        settled = true;
        window.clearTimeout(pollTimer);
        window.clearTimeout(deadlineTimer);
        state.identified = identified;
        state.gateReason = reason;
        state.status = eligible ? 'eligible' : 'identified';
        emit('vl:welcome-popup-identity-resolved', {
          eligible: eligible,
          reason: reason,
          identified: identified
        });
        resolve(eligible);
      }

      deadlineTimer = window.setTimeout(function () {
        finish(true, 'identification_timeout', null);
      }, timeoutMs);

      function poll() {
        if (settled || version !== runVersion) return;

        try {
          if (!window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') {
            pollTimer = window.setTimeout(poll, 50);
            return;
          }

          Promise.resolve(window.klaviyo.isIdentified()).then(
            function (identified) {
              if (identified === true) {
                finish(false, 'identified_browser', true);
                return;
              }

              finish(
                true,
                identified === false ? 'anonymous_browser' : 'identification_unknown',
                identified === false ? false : null
              );
            },
            function () {
              finish(true, 'identification_failed', null);
            }
          ).catch(function () {
            finish(true, 'identification_failed', null);
          });
        } catch (error) {
          finish(true, 'identification_failed', null);
        }
      }

      poll();
    });
  }

  function reserveDecision() {
    var existing = readDecision();

    if (!existing.ok) {
      state.status = 'blocked';
      state.gateReason = existing.reason;
      return null;
    }

    if (existing.decision) {
      state.status = 'suppressed_existing_decision';
      state.decision = existing.decision;
      return null;
    }

    var route = config.isHomepage ? 'homepage_experiment' : 'standard_welcome';
    var formId = route === 'standard_welcome' ? selectedStandardFormId() : null;

    if (route === 'standard_welcome' && !formId) {
      state.status = 'blocked';
      state.gateReason = 'standard_form_missing';
      return null;
    }

    var decision = {
      decisionVersion: DECISION_VERSION,
      route: route,
      status: 'reserved',
      reservationId: createId(),
      reservationOwnerId: pageInstanceId,
      createdAt: Date.now(),
      assignedGroup: null,
      actualExposure: false,
      autoOpenConsumed: false,
      reopenAvailable: false,
      reopenDismissed: false,
      completed: false,
      popupActive: false,
      popupActiveAt: null,
      popupOwnerId: null,
      manualFallback: null,
      quizProgress: null
    };

    if (route === 'homepage_experiment') {
      decision.ptStatus = 'reserved';
    } else {
      decision.formId = formId;
      decision.formStatus = 'reserved';
    }

    if (!writeDecision(decision)) {
      state.status = 'blocked';
      state.gateReason = 'storage_write_failed';
      return null;
    }

    state.status = 'reserved';
    state.decision = decision;
    emit('vl:welcome-popup-reserved', {
      route: route,
      formId: formId
    });

    return decision;
  }

  function releaseFallbackClaim(claimId) {
    try {
      var raw = window.localStorage.getItem(claimStorageKey);
      var claim = raw ? JSON.parse(raw) : null;
      if (claim && claim.claimId === claimId) {
        window.localStorage.removeItem(claimStorageKey);
      }
    } catch (error) {
      // The persistent decision remains authoritative if claim cleanup fails.
    }
  }

  function reserveWithFallbackClaim(attempt) {
    var currentAttempt = attempt || 0;
    var existing = readDecision();

    if (!existing.ok) {
      state.status = 'blocked';
      state.gateReason = existing.reason;
      return Promise.resolve(null);
    }

    if (existing.decision) {
      state.status = 'suppressed_existing_decision';
      state.decision = existing.decision;
      return Promise.resolve(null);
    }

    if (currentAttempt >= 12) {
      state.status = 'blocked';
      state.gateReason = 'claim_timeout';
      return Promise.resolve(null);
    }

    var claimId = createId();
    var now = Date.now();

    try {
      var raw = window.localStorage.getItem(claimStorageKey);
      var activeClaim = raw ? JSON.parse(raw) : null;

      if (activeClaim && activeClaim.expiresAt > now && activeClaim.claimId !== claimId) {
        return delay(60 + Math.floor(Math.random() * 60)).then(function () {
          return reserveWithFallbackClaim(currentAttempt + 1);
        });
      }

      window.localStorage.setItem(claimStorageKey, JSON.stringify({
        claimId: claimId,
        expiresAt: now + 1500
      }));
    } catch (error) {
      state.status = 'blocked';
      state.gateReason = 'claim_storage_failed';
      return Promise.resolve(null);
    }

    return delay(80 + Math.floor(Math.random() * 50)).then(function () {
      try {
        var verifiedRaw = window.localStorage.getItem(claimStorageKey);
        var verifiedClaim = verifiedRaw ? JSON.parse(verifiedRaw) : null;

        if (!verifiedClaim || verifiedClaim.claimId !== claimId) {
          return reserveWithFallbackClaim(currentAttempt + 1);
        }

        var decision = reserveDecision();
        releaseFallbackClaim(claimId);
        return decision;
      } catch (error) {
        state.status = 'blocked';
        state.gateReason = 'claim_verification_failed';
        return null;
      }
    });
  }

  function reserveAcrossTabs() {
    if (window.navigator.locks &&
        typeof window.navigator.locks.request === 'function') {
      state.lockStrategy = 'web_locks';
      return window.navigator.locks.request(lockName, { mode: 'exclusive' }, function () {
        return reserveDecision();
      }).catch(function () {
        state.lockStrategy = 'local_storage_claim';
        return reserveWithFallbackClaim(0);
      });
    }

    state.lockStrategy = 'local_storage_claim';
    return reserveWithFallbackClaim(0);
  }

  function triggerStandardWelcome(decision) {
    if (!decision || !decision.formId) return false;

    if (!updateDecision({
      autoOpenConsumed: true,
      reopenAvailable: true,
      popupActive: true,
      popupActiveAt: Date.now(),
      popupOwnerId: pageInstanceId,
      reservationOwnerId: null
    })) {
      state.status = 'blocked';
      state.gateReason = 'storage_update_failed';
      return false;
    }

    popupActive = true;
    setPopupLayerActive(true);
    state.activeFormId = decision.formId;
    state.formStatus = 'triggered';

    if (!updateDecision({ formStatus: 'triggered' })) {
      popupActive = false;
      setPopupLayerActive(false);
      state.status = 'blocked';
      state.gateReason = 'storage_update_failed';
      return false;
    }

    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', decision.formId]);
      scheduleKlaviyoOverlayMarking();
      scheduleFormOpenFallback();
      state.status = 'standard_welcome_triggered';
      emit('vl:welcome-popup-standard-triggered', {
        formId: decision.formId
      });
      return true;
    } catch (error) {
      popupActive = false;
      setPopupLayerActive(false);
      state.formStatus = 'failed';
      state.status = 'standard_welcome_failed';
      updateDecision({ formStatus: 'failed' });
      handleFormOpenFailure('standard_welcome_failed');
      return false;
    }
  }

  function sendPtEligibility(version) {
    var timeoutMs = Number(config.ptTimeoutMs) > 0
      ? Number(config.ptTimeoutMs)
      : 10000;
    var startedAt = Date.now();

    state.ptStatus = 'waiting_for_pt';
    updateDecision({ ptStatus: 'waiting_for_pt' });

    return new Promise(function (resolve) {
      function sendWhenReady() {
        if (version !== runVersion) {
          resolve(false);
          return;
        }

        if (window.ptengine && typeof window.ptengine.track === 'function') {
          state.ptStatus = 'sent';

          if (!updateDecision({ ptStatus: 'sent' })) {
            state.status = 'blocked';
            state.gateReason = 'storage_update_failed';
            resolve(false);
            return;
          }

          try {
            pageAutoAuthorized = true;
            window.ptengine.track(config.ptEventName);
            scheduleAssignmentFallback();
            state.status = 'homepage_eligibility_sent';
            emit('vl:welcome-popup-pt-sent', {
              eventName: config.ptEventName
            });
            resolve(true);
          } catch (error) {
            pageAutoAuthorized = false;
            state.ptStatus = 'failed';
            state.status = 'pt_failed';
            updateDecision({
              ptStatus: 'failed',
              autoOpenConsumed: true,
              reopenAvailable: true,
              manualFallback: 'standard_welcome',
              reservationOwnerId: null
            });
            resolve(false);
          }
          return;
        }

        if (Date.now() - startedAt >= timeoutMs) {
          state.ptStatus = 'pt_timeout';
          state.status = 'pt_timeout';
          updateDecision({
            ptStatus: 'pt_timeout',
            autoOpenConsumed: true,
            reopenAvailable: true,
            manualFallback: 'standard_welcome',
            reservationOwnerId: null
          });
          resolve(false);
          return;
        }

        window.setTimeout(sendWhenReady, 50);
      }

      sendWhenReady();
    });
  }

  function start() {
    if (startPromise) return startPromise;

    var version = runVersion;
    state.pathname = normalizePath(window.location.pathname);
    state.excluded = false;

    startPromise = Promise.resolve().then(function () {
      state.excluded = isExcludedPath(state.pathname);
      if (state.excluded) {
        state.status = 'excluded_path';
        state.gateReason = 'excluded_path';
        renderReopen();
        return false;
      }

      if (window.Shopify && window.Shopify.designMode) {
        state.status = 'design_mode';
        state.gateReason = 'design_mode';
        renderReopen();
        return false;
      }

      var existing = readDecision();

      if (!existing.ok) {
        state.status = 'blocked';
        state.gateReason = existing.reason;
        return false;
      }

      if (existing.decision) {
        if (!existing.decision.autoOpenConsumed) {
          var reservationTimeoutMs = Number(config.reservationTimeoutMs) > 0
            ? Number(config.reservationTimeoutMs)
            : 30000;
          var ownedByAnotherPage = Boolean(
            existing.decision.reservationOwnerId &&
            existing.decision.reservationOwnerId !== pageInstanceId &&
            Date.now() - existing.decision.createdAt < reservationTimeoutMs
          );

          if (ownedByAnotherPage) {
            state.status = 'suppressed_active_reservation';
            state.decision = existing.decision;
            renderReopen();
            return false;
          }

          updateDecision({
            autoOpenConsumed: true,
            reopenAvailable: true,
            manualFallback: 'standard_welcome',
            reservationOwnerId: null
          });
          existing = readDecision();
        }
        state.status = 'suppressed_existing_decision';
        state.decision = existing.decision;
        state.ptStatus = existing.decision.ptStatus || 'not_applicable';
        state.formStatus = existing.decision.formStatus || 'not_applicable';
        state.activeFormId = existing.decision.formId || null;
        state.actualExposure = existing.decision.actualExposure === true;
        renderReopen();
        return false;
      }

      return checkIdentity(version).then(function (eligible) {
        if (!eligible || version !== runVersion) return false;

        return reserveAcrossTabs().then(function (decision) {
          if (!decision || version !== runVersion) return false;

          return displayReadyPromise.then(function () {
            if (version !== runVersion) return false;

            if (decision.route === 'homepage_experiment') {
              return sendPtEligibility(version);
            }

            return triggerStandardWelcome(decision);
          });
        });
      });
    }).catch(function () {
      state.status = 'blocked';
      state.gateReason = 'coordinator_failed';
      return false;
    });

    return startPromise;
  }

  function canOpenHomepageExperiment() {
    var result = readDecision();
    return Boolean(
      pageAutoAuthorized &&
      result.ok &&
      result.decision &&
      result.decision.route === 'homepage_experiment' &&
      result.decision.ptStatus === 'sent' &&
      result.decision.autoOpenConsumed !== true &&
      result.decision.completed !== true &&
      result.decision.reopenDismissed !== true
    );
  }

  function claimHomepageAutoOpen(group) {
    var result = readDecision();
    var normalizedGroup = String(group || '').trim();

    if (!pageAutoAuthorized || !normalizedGroup || !result.ok || !result.decision ||
        result.decision.route !== 'homepage_experiment' ||
        result.decision.ptStatus !== 'sent' ||
        result.decision.autoOpenConsumed === true ||
        result.decision.completed === true ||
        result.decision.reopenDismissed === true ||
        (result.decision.assignedGroup &&
          result.decision.assignedGroup !== normalizedGroup)) {
      return false;
    }

    if (!updateDecision({
      assignedGroup: normalizedGroup,
      autoOpenConsumed: true,
      reopenAvailable: true,
      popupActive: true,
      popupActiveAt: Date.now(),
      popupOwnerId: pageInstanceId,
      reservationOwnerId: null
    })) return false;

    pageAutoAuthorized = false;
    popupActive = true;
    clearAssignmentTimer();
    renderReopen();

    emit('vl:welcome-popup-homepage-assigned', {
      experimentGroup: normalizedGroup
    });
    return true;
  }

  function markAssigned(group) {
    return claimHomepageAutoOpen(group);
  }

  function markExposure(detail) {
    var result = readDecision();
    var exposure = detail || {};

    if (!result.ok || !result.decision) return false;

    if (result.decision.route === 'homepage_experiment') {
      if (!result.decision.assignedGroup ||
          (exposure.experimentGroup &&
            result.decision.assignedGroup !== exposure.experimentGroup)) {
        return false;
      }
    } else if (result.decision.route === 'standard_welcome') {
      if (!exposure.formId ||
          (state.activeFormId && state.activeFormId !== exposure.formId)) {
        return false;
      }
    }

    if (!updateDecision({
      actualExposure: true,
      reopenAvailable: true,
      popupActive: true,
      popupActiveAt: Date.now(),
      popupOwnerId: pageInstanceId,
      manualFallback: null
    })) return false;

    popupActive = true;
    setPopupLayerActive(true);
    state.actualExposure = true;
    clearFormOpenTimer();
    renderReopen();
    emit('vl:welcome-popup-exposed', {
      route: result.decision.route,
      experimentGroup: exposure.experimentGroup || null,
      formId: exposure.formId || null,
      surface: exposure.surface || null
    });
    return true;
  }

  function markClosed(detail) {
    var closeDetail = detail || {};
    clearFormOpenTimer();
    popupActive = false;
    setPopupLayerActive(false);
    state.formStatus = 'closed';

    if (closeDetail.surface === 'klaviyo_form') {
      delayReopenRender();
    }

    return enableReopen('closed');
  }

  function markFormTriggered(detail) {
    var result = readDecision();
    var trigger = detail || {};

    if (!result.ok || !result.decision || !trigger.formId) return false;
    if (result.decision.route === 'homepage_experiment' &&
        (!result.decision.assignedGroup ||
          (trigger.experimentGroup &&
            result.decision.assignedGroup !== trigger.experimentGroup))) {
      return false;
    }

    popupActive = true;
    setPopupLayerActive(true);
    state.activeFormId = trigger.formId;
    state.formStatus = 'triggered';
    var updated = updateDecision({
      experimentFormId: trigger.formId,
      formStatus: 'triggered',
      popupActive: true,
      popupActiveAt: Date.now(),
      popupOwnerId: pageInstanceId
    });
    if (updated) {
      scheduleKlaviyoOverlayMarking();
      scheduleFormOpenFallback();
    } else {
      popupActive = false;
      setPopupLayerActive(false);
    }
    return updated;
  }

  function markOpenFailed(detail) {
    var failure = detail || {};
    clearFormOpenTimer();
    return handleFormOpenFailure(failure.reason || 'popup_open_failed');
  }

  function markCompleted(detail) {
    clearFormOpenTimer();
    clearReopenRenderTimer();
    popupActive = false;
    setPopupLayerActive(false);
    state.status = 'completed';
    state.formStatus = 'submitted';
    var completed = updateDecision({
      completed: true,
      reopenAvailable: false,
      popupActive: false,
      popupActiveAt: null,
      popupOwnerId: null,
      formStatus: detail && detail.formId ? 'submitted' : state.formStatus
    });
    renderReopen();
    return completed;
  }

  function dismissReopen() {
    clearReopenRenderTimer();
    popupActive = false;
    setPopupLayerActive(false);
    state.status = 'reopen_dismissed';
    var dismissed = updateDecision({
      reopenDismissed: true,
      reopenAvailable: false,
      popupActive: false,
      popupActiveAt: null,
      popupOwnerId: null
    });
    renderReopen();
    return dismissed;
  }

  function saveQuizProgress(progress) {
    var result = readDecision();
    if (!result.ok || !result.decision || result.decision.completed) return false;
    var value = progress && typeof progress === 'object' ? {
      version: String(progress.version || '2'),
      step: Number(progress.step) || 1,
      riderType: progress.riderType || null,
      riderDetail: progress.riderDetail || null
    } : null;
    return updateDecision({ quizProgress: value });
  }

  function getQuizProgress() {
    var result = readDecision();
    return result.ok && result.decision ? copy(result.decision.quizProgress) : null;
  }

  function triggerManualStandardWelcome() {
    var formId = selectedStandardFormId();
    if (!formId) return false;

    popupActive = true;
    setPopupLayerActive(true);
    state.activeFormId = formId;
    state.formStatus = 'triggered';
    renderReopen();

    if (!updateDecision({
      popupActive: true,
      popupActiveAt: Date.now(),
      popupOwnerId: pageInstanceId,
      manualFallback: 'standard_welcome'
    })) {
      popupActive = false;
      setPopupLayerActive(false);
      state.formStatus = 'failed';
      renderReopen();
      return false;
    }

    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
      scheduleKlaviyoOverlayMarking();
      scheduleFormOpenFallback();
      emit('vl:welcome-popup-standard-triggered', {
        formId: formId,
        source: 'reopen'
      });
      return true;
    } catch (error) {
      state.formStatus = 'failed';
      enableReopen('manual_standard_failed');
      return false;
    }
  }

  function reopenManually() {
    var result = readDecision();
    if (!result.ok || !result.decision || state.excluded || popupActive ||
        result.decision.completed || result.decision.reopenDismissed ||
        result.decision.popupActive ||
        !result.decision.reopenAvailable) {
      return Promise.resolve(false);
    }

    var decision = result.decision;
    if (config.isHomepage && decision.route === 'homepage_experiment' &&
        decision.assignedGroup && window.VLHomepageRiderQuiz &&
        (decision.manualFallback !== 'standard_welcome' ||
          decision.actualExposure === true) &&
        typeof window.VLHomepageRiderQuiz.openManual === 'function') {
      popupActive = true;
      if (!updateDecision({
        popupActive: true,
        popupActiveAt: Date.now(),
        popupOwnerId: pageInstanceId
      })) {
        popupActive = false;
        renderReopen();
        return Promise.resolve(false);
      }
      renderReopen();
      return Promise.resolve(
        window.VLHomepageRiderQuiz.openManual(decision.assignedGroup)
      ).then(function (opened) {
        if (!opened) enableReopen('manual_homepage_failed');
        return opened;
      }, function () {
        enableReopen('manual_homepage_failed');
        return false;
      });
    }

    return Promise.resolve(triggerManualStandardWelcome());
  }

  function clearDecision() {
    runVersion += 1;
    pageAutoAuthorized = false;
    popupActive = false;
    setPopupLayerActive(false);
    clearFormOpenTimer();
    clearAssignmentTimer();
    clearReopenRenderTimer();

    try {
      window.localStorage.removeItem(storageKey);
      window.localStorage.removeItem(claimStorageKey);
    } catch (error) {
      state.storageStatus = 'clear_failed';
      return false;
    }

    startPromise = null;
    state.status = 'idle';
    state.excluded = false;
    state.identified = null;
    state.gateReason = null;
    state.storageStatus = 'available';
    state.lockStrategy = null;
    state.decision = null;
    state.ptStatus = 'idle';
    state.formStatus = 'idle';
    state.activeFormId = null;
    state.actualExposure = false;
    state.reopenVisible = false;
    renderReopen();
    emit('vl:welcome-popup-decision-cleared');
    return true;
  }

  function getState() {
    var result = readDecision();
    var decision = result.ok ? result.decision : state.decision;

    return {
      status: state.status,
      pathname: state.pathname,
      excluded: state.excluded,
      identified: state.identified,
      gateReason: state.gateReason,
      storageStatus: state.storageStatus,
      lockStrategy: state.lockStrategy,
      decision: copy(decision),
      ptStatus: state.ptStatus,
      formStatus: state.formStatus,
      activeFormId: state.activeFormId,
      actualExposure: state.actualExposure,
      pageAutoAuthorized: pageAutoAuthorized,
      popupActive: popupActive,
      reopenVisible: state.reopenVisible,
      displayStatus: state.displayStatus,
      displayDelayMs: Number(config.displayDelayMs) >= 0
        ? Number(config.displayDelayMs)
        : 2000,
      implementationVersion: state.implementationVersion
    };
  }

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event && event.detail ? event.detail : {};
    var result = readDecision();

    if (!detail.formId || !result.ok || !result.decision ||
        detail.formId !== state.activeFormId) {
      return;
    }

    if (detail.type === 'open') {
      clearFormOpenTimer();
      popupActive = true;
      setPopupLayerActive(true);
      scheduleKlaviyoOverlayMarking();
      state.formStatus = 'opened';
      updateDecision({
        formStatus: 'opened',
        reopenAvailable: true,
        actualExposure: true,
        popupActive: true,
        popupActiveAt: Date.now(),
        popupOwnerId: pageInstanceId,
        manualFallback: result.decision.manualFallback
      });
      if (result.decision.route === 'standard_welcome') {
        markExposure({
          formId: detail.formId,
          surface: 'standard_klaviyo_form'
        });
      }
      renderReopen();
      return;
    }

    if (detail.type === 'close') {
      markClosed({
        formId: detail.formId,
        surface: 'klaviyo_form'
      });
      return;
    }

    if (detail.type === 'submit') {
      markCompleted({ formId: detail.formId });
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== storageKey) return;

    var result = readDecision();
    if (result.ok) state.decision = result.decision;
    if (result.ok && result.decision &&
        (result.decision.completed || result.decision.reopenDismissed)) {
      popupActive = false;
      setPopupLayerActive(false);
    }
    renderReopen();
  });

  window.addEventListener('pageshow', function () {
    popupActive = false;
    setPopupLayerActive(false);
    pageAutoAuthorized = false;
    renderReopen();
  });

  window.addEventListener('pagehide', function () {
    clearReopenRenderTimer();
    pageAutoAuthorized = false;
    popupActive = false;
    setPopupLayerActive(false);
    var result = readDecision();
    if (result.ok && result.decision) {
      var release = {};
      var shouldWrite = false;

      if (result.decision.popupOwnerId === pageInstanceId) {
        release.popupActive = false;
        release.popupActiveAt = null;
        release.popupOwnerId = null;
        shouldWrite = true;
      }

      if (!result.decision.autoOpenConsumed &&
          result.decision.reservationOwnerId === pageInstanceId) {
        release.autoOpenConsumed = true;
        release.reopenAvailable = true;
        release.manualFallback = 'standard_welcome';
        release.reservationOwnerId = null;
        shouldWrite = true;
      }

      if (shouldWrite) updateDecision(release);
    }
  });

  if (reopenRoot) {
    var reopenButton = reopenRoot.querySelector('[data-vl-welcome-popup-reopen-button]');
    var dismissButton = reopenRoot.querySelector('[data-vl-welcome-popup-reopen-dismiss]');
    if (reopenButton) reopenButton.addEventListener('click', reopenManually);
    if (dismissButton) dismissButton.addEventListener('click', dismissReopen);
  }

  window[GLOBAL_NAME] = Object.freeze({
    start: start,
    getState: getState,
    clearDecision: clearDecision,
    canOpenHomepageExperiment: canOpenHomepageExperiment,
    claimHomepageAutoOpen: claimHomepageAutoOpen,
    markAssigned: markAssigned,
    markExposure: markExposure,
    markFormTriggered: markFormTriggered,
    markOpenFailed: markOpenFailed,
    markClosed: markClosed,
    markCompleted: markCompleted,
    dismissReopen: dismissReopen,
    reopenManually: reopenManually,
    saveQuizProgress: saveQuizProgress,
    getQuizProgress: getQuizProgress
  });

  start();
})();
